var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReturns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.04,
    height: 23.04,
    viewBox: "0 0 23.04 23.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04 23.043a.713.713 0 0 1-.509-.211l-4.32-4.32a.721.721 0 0 1-.156-.235l-.009-.023a.7.7 0 0 1 0-.5c0-.011.008-.021.012-.03a.71.71 0 0 1 .154-.228l4.32-4.32a.72.72 0 1 1 1.018 1.018L2.458 17.28H18a3.6 3.6 0 0 0 3.6-3.6V5.043a3.6 3.6 0 0 0-3.6-3.6h-7.92a.72.72 0 1 1 0-1.44H18a5.046 5.046 0 0 1 5.04 5.04v8.64A5.046 5.046 0 0 1 18 18.72H2.459l3.091 3.091a.72.72 0 0 1-.51 1.232z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturns);
export default __webpack_public_path__ + "static/media/icon-returns.c2a21f4d.svg";
export { ForwardRef as ReactComponent };